import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import { MuiThemeProvider } from "@material-ui/core";
import { CookiesProvider } from 'react-cookie';
import PathError from './screens/PathError/index';
import Login from './screens/Login/LoginPage';
import MainPage from './screens/MainPage/MainPage';
import Register from './screens/Register/RegisterPage';
import SignOutRedirect from './screens/SignoutRedirect/SignoutRedirectPage';
import RecoverPassword from './screens/RecoverPassword/RecoverPasswordPage';
import { store } from "./apis/redux";
import AuthService from "./apis/amplify/AuthService";
import PrivateRoute from "./apis/routes/PrivateRoute";
import PropsRoute from "./apis/routes/PropsRoute";
import { initializeFirebaseApp, initializeFirebaseMessaging } from "./apis/firebase";
import { push_notification } from './apis/redux/fetchActions'
import { theme } from './theme';

initializeFirebaseApp();
initializeFirebaseMessaging({
    dispatch: (...args) => store.dispatch(...args),
    notifReceivedActionBuilder: push_notification
});

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            loading: true
        };
        this.setIsAuthenticated = this.setIsAuthenticated.bind(this);
    }

    setIsAuthenticated(isLoggedIn) {
        this.setState({isLoggedIn: isLoggedIn, loading: false});
    }

    componentDidMount() {
        AuthService.isLoggedIn()
            .then(authData => {
                this.setIsAuthenticated(authData)
            })
            .catch(console.log);
    }


    render() {
        const {isLoggedIn, loading} = this.state;
        if (loading === true)
            return null;
        return (
            <MuiThemeProvider theme={theme}>
                <CookiesProvider>
                    <Provider store={store}>
                        <BrowserRouter>
                            <Switch>
                                <PropsRoute path="/login" exact component={Login}
                                            setIsLoggedIn={this.setIsAuthenticated}/>
                                <PropsRoute path="/register" exact component={Register}/>
                                <PropsRoute path="/redirecting" exact component={SignOutRedirect}/>
                                <PropsRoute path="/recover_password" exact component={RecoverPassword}/>

                                <PrivateRoute exact path="/" render={() => <Redirect to="/fix/devices"/>}/>
                                <PrivateRoute path="/" component={MainPage}
                                       isLoggedIn={isLoggedIn}
                                       setIsLoggedIn={this.setIsAuthenticated}/>
                                <PropsRoute component={PathError}/>
                            </Switch>
                        </BrowserRouter>
                    </Provider>
                </CookiesProvider>
            </MuiThemeProvider>
        )
    };
}

export default (App);
